import { CookieStorage, CookieOptions } from "./cookie";

export class SafeStorage {
  private static memoryStore: Record<string, string> = {};

  public static getItem(key: string): string | null {
    // 1. Try Cookie first (first-party persistence across subdomains)
    const cookieVal = CookieStorage.get(key);
    if (cookieVal) return cookieVal;

    // 2. Try localStorage
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        const localVal = window.localStorage.getItem(key);
        if (localVal) return localVal;
      }
    } catch {}

    // 3. Fallback to memory
    return this.memoryStore[key] || null;
  }

  public static setItem(key: string, value: string, cookieOptions?: CookieOptions): void {
    // Store in cookie
    CookieStorage.set(key, value, cookieOptions);

    // Store in localStorage as backup
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.setItem(key, value);
      }
    } catch {}

    // Always keep in memory
    this.memoryStore[key] = value;
  }

  public static removeItem(key: string, cookieOptions?: CookieOptions): void {
    CookieStorage.remove(key, cookieOptions);
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.removeItem(key);
      }
    } catch {}
    delete this.memoryStore[key];
  }
}
